import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";

const SubcategoryDiscountFields = ({ form, handleNestedChange, setForm }) => {
  const handleSubcategoryChange = (e) => {
    const value = e.target.value;
    setForm((prev) => ({
      ...prev,
      appliesTo: {
        ...prev.appliesTo,
        subcategories: typeof value === "string" ? value.split(",") : value,
      },
    }));
  };

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          select
          label="Target Subcategories"
          value={form.appliesTo?.subcategories || []}
          onChange={handleSubcategoryChange}
          SelectProps={{ multiple: true }}>
          <MenuItem value="cupcake">Cupcakes</MenuItem>
          <MenuItem value="macaron">Macarons</MenuItem>
          <MenuItem value="cakeSlice">Cake Slices</MenuItem>
          <MenuItem value="pastry">Pastries</MenuItem>
          <MenuItem value="cheesecakeSlice">Cheesecake Slices</MenuItem>
          <MenuItem value="cookie">Cookies</MenuItem>
        </TextField>
      </Grid>

      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Discount Value"
          type="number"
          value={form.config.discountValue || ""}
          onChange={(e) =>
            handleNestedChange(
              "config",
              "discountValue",
              Number(e.target.value)
            )
          }
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          fullWidth
          select
          label="Discount Type"
          value={form.config.discountType || "percentage"}
          onChange={(e) =>
            handleNestedChange("config", "discountType", e.target.value)
          }>
          <MenuItem value="percentage">%</MenuItem>
          <MenuItem value="fixed">$</MenuItem>
        </TextField>
      </Grid>
    </Grid>
  );
};

export default SubcategoryDiscountFields;
